const FormTitle = ({text, customClass, noSpace}) => (
  <h3 className={`source-24 s-cols-1 ${noSpace ? 'mb-20' : 'mt-20 mb-20'} m-cols-2 ${customClass}`}>{text}</h3>
);

export default FormTitle
